<template>
	<validation-observer
		ref="observer"
		tag="div"
		class="observer"
	>
        <div>
			<div class="grid grid-cols-6 gap-6 mt-6" v-if="!showAddtionalPeopleForm">
				<div class="col-span-6 sm:col-span-3">
				<validation-provider
					ref="name"
					name="name"
					rules="required"
					v-slot="{ errors }"
				>
					<label
						for="first_name"
						class="block text-sm font-medium text-gray-700"
						>First Name</label
					>
					<input
						v-model="form.name.value"
						type="text"
						name="first_name"
						id="first_name"
                        maxlength="50"
                           autocomplete="given-name"
                           class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                           :class="{
							'border-2 border-red-300 placeholder-red-300': errors.length,
							'border border-gray-300 ': !errors.length,
						}"
                    />
                    <p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">{{ errors[0] }}</p>
                    <p class="mt-2 text-sm text-red-600 validation-error" v-if="form?.name?.value?.length > 49">
                        Maximum 50 characters allowed
                    </p>
                </validation-provider>
            </div>

            <div class="col-span-6 sm:col-span-3">
				<validation-provider
					ref="surname"
					name="surname"
					rules="required"
					v-slot="{ errors }"
				>
					<label for="last_name" class="block text-sm font-medium text-gray-700"
						>Last Name</label
					>
					<input
						v-model="form.surname.value"
						type="text"
						name="last_name"
						id="last_name"
                        maxlength="50"
                           autocomplete="family-name"
                           class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                           :class="{
							'border-2 border-red-300 placeholder-red-300': errors.length,
							'border border-gray-300 ': !errors.length,
						}"
					/>
					<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
						{{ errors[0] }}
					</p>
                    <p class="mt-2 text-sm text-red-600 validation-error" v-if="form?.surname?.value?.length > 49">
                        Maximum 50 characters allowed
                    </p>
                </validation-provider>
            </div>


            <div class="col-span-6 sm:col-span-4" v-if="!isBusinessFlow()">
                <label for="last_name" class="block text-sm font-medium text-gray-700">
					Date of Birth
				</label>
				<label for="last_name" class="text-xs text-gray-500">
					For example: 27 03 1972
				</label>
                <div id="ageValidationScroll" class="grid grid-cols-12 gap-2 mt-1">
                    <validation-provider
						class="col-span-4 sm:col-span-3 dob__day"
						tag="div"
						ref="day"
						name="day"
						v-slot="{ errors }"
					>
						<fieldset>
							<div class="field-inline-block">
								<input
									v-model="form.dateOfBirth.day.value"
									name="day"
									autocomplete="bday-day"
									@focus="isDayPlaceholderClicked = true"
    								@blur="isDayPlaceholderClicked = false"
    								:placeholder="isDayPlaceholderClicked ? '' : 'Day'"
									type="text"
									inputmode="numeric"
									pattern="[0-9]*"
									min="1"
									max="31"
									maxlength="2"
									@input="moveToNext($event, 'month')"
									class="block w-full pl-3 py-2 text-base focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
									:class="{
									'border-2 border-red-300 placeholder-red-300': errors.length,
									'border border-gray-300 ': !errors.length,
									}"
								/>
							</div>
							<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
								{{ errors[0] }}
							</p>
						</fieldset>
                    </validation-provider>

					<validation-provider
						class="col-span-4 sm:col-span-3 dob__month"
						tag="div"
						ref="month"
						name="month"
						v-slot="{ errors }"
					>
						<fieldset>
							<div class="field-inline-block">
								<input
									v-model="form.dateOfBirth.month.value"
									name="month"
									autocomplete="bday-month"
									@focus="isMonthPlaceholderClicked = true"
    								@blur="isMonthPlaceholderClicked = false"
    								:placeholder="isMonthPlaceholderClicked ? '' : 'Month'"
									type="text"
									inputmode="numeric"
									pattern="[0-9]*"
									min="1"
									max="12"
									maxlength="2"
									@input="moveToNext($event, 'year')"
									class="col-span-4 sm:col-span-6 block w-full pl-3 py-2 text-base focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
										:class="{
										'border-2 border-red-300 placeholder-red-300': errors.length,
										'border border-gray-300 ': !errors.length,
										}"
									/>
							</div>
							<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
								{{ errors[0] }}
							</p>
						</fieldset>
                    </validation-provider>

                    <validation-provider
						class="col-span-4 sm:col-span-3 dob__year"
						tag="div"
						ref="year"
						name="year"
						v-slot="{ errors }"
					>
						<fieldset>
							<div class="field-inline-block">
								<input
									v-model="form.dateOfBirth.year.value"
									name="year"
									autocomplete="bday-year"
									@focus="isYearPlaceholderClicked = true"
    								@blur="isYearPlaceholderClicked = false"
    								:placeholder="isYearPlaceholderClicked ? '' : 'Year'"
									type="text"
									inputmode="numeric"
									pattern="[0-9]*"
									maxlength="4"
									size="4"
									@input="moveToNext($event)"
									class="col-span-4 sm:col-span-3 block w-full pl-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
										:class="{
										'border-2 border-red-300 placeholder-red-300': errors.length,
										'border border-gray-300 ': !errors.length,
										}"
									/>
							</div>
							<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length && !(isAllDateFieldsFilled && !form.isValidDate.value)">
								{{ errors[0] }}
							</p>
						</fieldset>
                    </validation-provider>
                </div>
				<p v-if="(isAllDateFieldsFilled && !form.isValidDate.value) && form.isValidAge.value" class="mt-2 text-sm text-red-600 validation-error">
					Please enter a valid date of birth
				</p>
				<p v-if="dobError" class="mt-2 text-sm text-red-600 validation-error">
					The Date of Birth is required
				</p>
				<p class="mt-2 text-sm text-red-600 validation-error" v-if="isAllDateFieldsFilled && !form.isValidAge.value">
                    You must be at least 17 years old.
                </p>
            </div>

            <div class="col-span-6 sm:col-span-3">
				<validation-provider
					ref="email"
					name="email"
					rules="required|email"
					v-slot="{ errors }"
				>
					<label for="email" class="block text-sm font-medium text-gray-700"
						>Email Address</label
					>
					<input
						v-model="form.email.value"
						type="text"
						name="email"
						id="email"
						autocomplete="email"
                        class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        :class="{
							'border-2 border-red-300 placeholder-red-300': errors.length,
							'border border-gray-300 ': !errors.length,
                		}"
                    />
					<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
						{{ errors[0] }}
					</p>
                </validation-provider>
            </div>

            <div class="col-span-6 sm:col-span-3">
                <validation-provider ref="phone" name="phone" :rules="phoneValidationRules"
                                     v-slot="{ errors, touched }">
                    <label for="email" class="block text-sm font-medium text-gray-700">Phone Number</label>
                    <div class="mt-1 flex rounded-md shadow-sm">
						<input 
							v-model="form.phone.value"
							type="tel"
							name="phone"
							id="phone"
							autocomplete="phone"
							class="focus:ring-blue-500 focus:border-blue-500 flex-1 block w-full px-3 py-2 rounded-md sm:text-sm "
							:class="{
								'border-2 border-red-300 placeholder-red-300': errors.length,
								'border border-gray-300 ': !errors.length,
							}"
                        />
                    </div>
                  <p class="mt-2 text-sm text-red-600 validation-error"
                     v-if="errors.length && (touched || form.phone?.value?.length >= 11 || form.phone?.value?.match(/[A-Za-z]/)) || !phoneInputted">
                    {{ errors[0] }}
					</p>
                </validation-provider>
            </div>

            <div class="col-span-6 sm:col-span-3" v-if="isBusinessFlow()">
                <validation-provider ref="named_contact" name="named_contact" rules="" v-slot="{ errors }">
                    <label for="named_contact" class="block text-sm font-medium text-gray-700">Named Contact (optional)</label>
                    <input v-model="form.named_contact.value" type="text" name="named_contact" id="named_contact"
                           autocomplete="given-name"
                           class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                           :class="{
                    'border-2 border-red-300 placeholder-red-300':errors.length,
                    'border border-gray-300 ': !errors.length
                }"
                    >
                    <p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">{{ errors[0] }}</p>
                </validation-provider>
            </div>

            <div class="col-span-6 sm:col-span-3" v-if="!isBusinessFlow()">
                <validation-provider ref="postcode" name="postcode" v-slot="{ errors }" rules="required">
                    <label for="postcode" class="block text-sm font-medium text-gray-700">Postcode</label>
                    <div class="flex justify-between mt-1">
						<input
							v-model="form.address.postcode.value"
							type="text"
							name="postcode"
							id="postcode"
							dusk="D-postcodeInput"
                            autocomplete="postal-code"
                           	class="uppercase block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                           	:class="{
								'border-2 border-red-300 placeholder-red-300': errors.length && !hideManualPostcodeError,
								'border border-gray-300 ': !errors.length || hideManualPostcodeError,
                			}"
                        />
                        <button @click="validateValidPostcode(form.address,'postcode')" type="button"
							dusk="postcode-lookup-button"
							data-testid="postcode-lookup"
							class="white-label-btn-text ml-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-none rounded-md shadow-sm text-black bg-cyan focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-poppins font-semibold"
							:class="{
								'opacity-50 cursor-default': !form.address.postcode.value,
								'cursor-pointer': form.address.postcode.value,
								'text-white': whiteButtonText,
								/* Autofill split test, we hide the lookup bottom, and re-enable if user changes value */
								'hidden': (hasAutofilled && !postcodeChanged && form.address.manual && !errors.length && form.address.postcode?.value?.length !== 0) || (hasAutofilled && !showLookupSplitTest)
                            }"
                        >
                            Lookup
                        </button>
                    </div>
					<p class="mt-2 text-sm text-red-600 validation-error" v-if='!errors.length && postcodeErrorMessage !== ""'>
						{{ postcodeErrorMessage }}
					</p>
					<p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
						{{ errors[0] }}
					</p>
                </validation-provider>
            </div>

            <div class="col-span-6" v-if="!form.address.manual && !isBusinessFlow()">
                <validation-provider ref="address" name="address" rules="required" v-slot="{ errors }">
                    <div v-if="form.address.results || errors.length">
                        <label v-if="form.address.results" for="location" class="block text-sm font-medium text-gray-700">Address</label>
                        <select v-if="form.address.results" @change="selectAddress(form.address)" v-model="form.address.value" id="location"
                                name="location"
                                dusk="D-addressLookup"
                                class="mt-1 block w-full pl-3 pr-10 py-2 text-base focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                                :class="{
								'border-2 border-red-300 placeholder-red-300': errors.length,
								'border border-gray-300 ': !errors.length,
                    }"
                        >
                            <option disabled selected value="">Please select your address</option>
							<option
								v-for="result in form.address.results"
								:value="result.value"
								:key="result.value"
								>{{ result.label }}
                            </option>
                        </select>
                        <p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
                            <span v-if="form.address.results">Please choose an address to continue.</span>
                        </p>
                    </div>
                </validation-provider>
				<div class="flex justify-start mt-2" v-if="!rearrangePanelSplitTest">
                    <a href="javascript:void(0)" @click="toggleManualAddress(form.address)"
                       class="hover:underline text-gray-500 inline-block text-sm font-bold">
                        Can't find your address?
                    </a>
                </div>
				<!-- v-else used for ticket 712 split test -->
				<div class="flex justify-between items-center mt-4" :class="showSaveButton ? 'mt-4' : 'mt-2'" v-else>
					<div class="flex justify-start">
						<a href="javascript:void(0)" @click="toggleManualAddress(form.address)"
						class="hover:underline text-gray-500 inline-block text-sm font-bold">
							Can't find your address?
						</a>
					</div>
					<div class="flex justify-end" v-if="showSaveButton">
						<button @click="savePersonalDetails" type="button" dusk="D-saveCustomerDetails" id="save-button-your-details"
								class="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
							Save
						</button>
					</div>
				</div>

            </div>
			</div>


			<div class="col-span-6">

				<div v-if="form?.cover_type?.value === COVER_TYPE.personalCover && showAddtionalPeopleForm" id="people-form">

					<user-details
						v-for="(person,index) in this.people"
						:form="form"
						:key="index"
						:index-number="index"
						ref="userDetailsExtraPeople"
						:name="person.name.value"
						:surname="person.surname.value"
						:phone="person.phone.value"
						:additional-people-form="true"
						:day-value.sync="person.dateOfBirth.day.value"
						:month-value.sync="person.dateOfBirth.month.value"
						:year-value.sync="person.dateOfBirth.year.value"
						@update:name="updatePeople(index, 'name', $event)"
						@update:surname="updatePeople(index, 'surname', $event)"
						@update:phone="updatePeople(index, 'phone', $event)"
						@update:day="updatePeople(index, 'day', $event)"
						@update:month="updatePeople(index, 'month', $event)"
						@update:year="updatePeople(index, 'year', $event)">
					</user-details>
					<p v-if="this.phoneErrorMessage" class="mb-1 mt-1 md:mb-2 md:mt-0 text-sm text-red-600">
                        {{ this.phoneErrorMessage }}
                    </p>
					<button v-if="!this.maxAdditionalMembersAdded" type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" @click.prevent="addAdditionalPerson" :class="{ 'mt-4': this.people.length === 0, 'mt-6 md:mt-4': this.people.length > 0 }">
						Add Another Member
					</button>
					<p v-else class="mt-3 text-sm text-red-600">
						A maximum of 4 members can be added.
					</p>
				</div>
            </div>

			<div 
				id="manual-form" 
				v-cloak 
				class="col-span-6 grid grid-cols-6 gap-6"
				v-if="!isBusinessFlow() && !hideManualAddressForm"
				:class="{
					'mt-6': form.address.manual,
					'hidden': !form.address.manual && (hasAddressResults || !autofillAddressSplitTest || postcodeErrorMessage !== ''),
					'h-0 overflow-hidden': !hasAddressResults && !form.address.manual
				}"
			>
                <div class="col-span-6 sm:col-span-3">
					<validation-provider
						ref="address_line_1"
						name="address_line_1"
						v-slot="{ errors }"
					>
						<label
							for="address_line_1"
							class="block text-sm font-medium text-gray-700"
							>Address Line 1</label
						>
						<div class="flex justify-between">
							<input
								v-model="form.address.line1.value"
								type="text"
								name="address_line_1"
								id="address_line_1"
								autocomplete="address-line1"
								class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
							/>
						</div>
						<p v-if="errors.length" class="mt-2 text-sm text-red-600 validation-error">{{ errors[0] }}</p>
						<p v-if="addressLine1Error !== ''" class="mt-2 text-sm text-red-600 validation-error">
							{{ addressLine1Error }}
						</p>
					</validation-provider>
                </div>

				<!-- Placeholder to fill in col-span space on the right -->
				<div class="col-span-3 hidden md:flex"></div>

                <div class="col-span-6 sm:col-span-3">
					<label
						for="address_line_2"
						class="block text-sm font-medium text-gray-700"
						>Address Line 2</label
					>
					<div class="flex justify-between">
						<input
							v-model="form.address.line2.value"
							type="text"
							name="address_line_2"
							id="address_line_2"
							autocomplete="address-line2"
							class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
						/>
					</div>
                </div>

				<!-- Placeholder to fill in col-span space on the right -->
				<div class="col-span-3 hidden md:flex"></div>

                <div class="col-span-6 sm:col-span-3">
					<label
						for="address_line_3"
						class="block text-sm font-medium text-gray-700"
						>Address Line 3</label
					>
					<div class="flex justify-between">
						<input
							v-model="form.address.line3.value"
							type="text"
							name="address_line_3"
							id="address_line_3"
							autocomplete="address-line3"
							class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
						/>
					</div>
                </div>

				<!-- Placeholder to fill in col-span space on the right -->
				<div class="col-span-3 hidden md:flex"></div>

                <div class="col-span-6 sm:col-span-6 md:col-span-2">
					<validation-provider
						ref="town"
						name="town"
						v-slot="{ errors }"
					>
						<label for="town" class="block text-sm font-medium text-gray-700"
							>Town / City</label
						>
						<input
							v-model="form.address.town.value"
							type="text"
							name="town"
							id="town"
							class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
						/>
						<p v-if="errors.length" class="mt-2 text-sm text-red-600 validation-error">{{ errors[0] }}</p>
					</validation-provider>
                </div>

                <div v-if="false">
				<manually-save-address
					:toggle-action="saveAddress"
                	:data="form.address"
				>
				</manually-save-address>
                </div>

            </div>
        </div>
	</validation-observer>
</template>



<script>
import { extend } from 'vee-validate';
import UserDetails from './UserDetails.vue'
import { COVER_TYPE } from "../../constants";
import ManuallySaveAddress from '../ManuallySaveAddress';
import { mapGetters } from "vuex";
import { isValidPostcode } from '../../common/address';

export default {
    name: 'PersonalDetails',
	components: {
		UserDetails,
        ManuallySaveAddress
    },
    props: {
        form: {
            type: Object,
            default: () => ({}),
			isValidAge: false,
			isValidDate: false
        },
        whiteButtonText: {
            type: Boolean,
            default: false
        },
		showAddtionalPeopleForm: {
            type: Boolean,
            default: false
        },
		phoneErrorMessage: {
            type: [String, null],
            default: null,
        },
		hideManualAddressForm: {
			type: Boolean,
			default: false
		},
		rearrangePanelSplitTest: {
			type: Boolean,
			default: false
		},
		showSaveButton: {
			type: Boolean,
			default: false
		},
		autofillAddressSplitTest: {
			type: Boolean,
			default: false
		},
		showLookupSplitTest: {
			type: Boolean,
			default: false
		},
    },
	data() {
        return {
            isAllDateFieldsFilled: false,
			dobError: false,
            postcodeValid: false,
            phoneInputted: false,
            surnameInputted: false,
            nameInputted: false,
            personalDetailsInputted: false,
            dobComplete: false,
			isDayPlaceholderClicked: false,
			isMonthPlaceholderClicked: false,
			isYearPlaceholderClicked: false,
			COVER_TYPE: COVER_TYPE,
			addressLine1Error: '',
			postcodeErrorMessage: "",
            hideManualPostcodeError: false,
            searchedPostcode: null,
            postcodeChanged: false,
            postcodeResearched: false,
			maxAdditionalMembersAdded: false,
			hasAddressResults: false,
			hasAutofilled: false,
			postcodeNotFoundError: 'Postcode not found. Please manually enter your address below.',
			lineOneAutofillValue: null
        };
    },
    methods: {
		savePersonalDetails() {
			this.$emit('save-personal-details', true)
		},
		updatePeople(index, field, value) {
            this.$store.commit('UPDATE_PEOPLE', { index, field, value })
        },
		moveToNext(event, nextRef) {
			// Accept only numeric input
			event.target.value = event.target.value.replace(/\D/g, '');

			this.form.dateOfBirth[event.target.name].value = event.target.value;

			// Check the inputs length has 2 characters before moving onto the next input
			if (event.target.value.length === 2) {
				this.$refs[nextRef]?.$el.querySelector('input').focus();
			}
		},
		addAdditionalPerson() {

			const currentPeopleCount = this.$store.state.people.length;

			if (currentPeopleCount === 3) {
				return;
			}

			const updatedPeople = [...this.$store.state.people];

			updatedPeople.push(this.getEmptyPeopleInfo());
			this.$store.commit("SET_PEOPLE", updatedPeople);
		},
        isBusinessFlow() {
            return window.isBusiness;
        },
		async validates() {
			if (!this.isBusinessFlow()) {
				this.validateAge();
				this.validateDate();
				this.postcodeErrorMessage = ""
				
				if(!this.form.dateOfBirth.day.value || !this.form.dateOfBirth.month.value || !this.form.dateOfBirth.year.value) {
					this.dobError = true;
				} else {
					this.dobError = false;
				}

				// If the form is manual and all fields are filled, then we do not need to run validateValidPostcode/lookup postcode - just run some validation checks for the postcode
				// So in instances where user doesn't look up, click 'can't find address', it will not run validateValidPostcode/lookup postcode on submit
				const isManualForm = this.form.address.manual && this.form.address.line1.value && this.form.address.postcode.value;

				const postHasChanged = this.searchedPostcode && this.form.address.postcode.value && (this.searchedPostcode.replace(/\s+/g, "").toLowerCase() !== this.form.address.postcode.value.replace(/\s+/g, "").toLowerCase())


				if (!this.form.address.postcode.value) {
					this.postcodeErrorMessage = "This field is required."
					this.form.address.postcodeError = this.postcodeErrorMessage
				}

				if(isManualForm) {
					const postcodeValidation = isValidPostcode(this.form.address.postcode.value)
					await this.$refs.observer.validate();
				
					if(!postcodeValidation.isValid) {
						this.postcodeErrorMessage = postcodeValidation.errorMessage

						return false
					}

				// manual form is not open and postcode has changed or not searched then run validateValidPostcode to auto lookup
				} else if(!isManualForm && (!this.searchedPostcode || postHasChanged)) {
					await this.$refs.observer.validate();
					await this.validateValidPostcode()

					return false
				}

				// Don't close manual address form if there's existing errors.
				if (this.form.address.manual) {
					if (this.dobError || this.postcodeErrorMessage !== "") {
						return false
					} else {
						this.saveAddress()
					}
				}
			}

            return await this.$refs.observer.validate();
        },
		saveAddress() {
			this.addressLine1Error = ''

			if (!this.form.address.line1.value) {
				this.addressLine1Error = 'This field is required'
			}
			
			if(this.form.address.line1.value && this.form.address.postcode.value) {
				this.addressLine1Error = ''
				this.toggleManualAddress(this.form.address)
			}
		},
        validateAge() {
			this.form.isValidAge.value = this.ageValidator(this.form.dateOfBirth, this.form.isValidAge.value)
        },
		validateDate() {
            if(!this.isBusinessFlow()) {
				this.form.isValidDate.value = this.dateValidator(this.form.dateOfBirth);
            }
		},
        allFieldsInputted(postcodeValid, phoneInputted, dobComplete, surnameInputted, nameInputted){
            if(this.isBusinessFlow()){
                dobComplete = true;
            }

            if(postcodeValid && phoneInputted && surnameInputted && dobComplete && nameInputted){
                this.$emit('confirming-personal-details', true)
            } else {
                this.$emit('confirming-personal-details', false)
            }
        },
		async validateValidPostcode() {
			const postcodeValidation = await this.$refs.postcode.validate()

			if(!postcodeValidation.valid) {
				return false
			}

			this.postcodeErrorMessage = ""

			// Worth extracting and re-using isValidPostcode from address.js as we needed the validation check within validates()
            // UK Postcode regex format
			const postcodeRegex = /^([GIR]0AA)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9][A-Z]?))))[0-9][A-Z]{2})$/

			// Remove spaces from lookup, additional null checker
			const postcodeLookupResult = this.form.address.postcode.value ? this.form.address.postcode.value.replace(/\s+/g, "").toUpperCase() : null
			
            if(this.searchedPostcode && this.searchedPostcode !== postcodeLookupResult) {
                this.postcodeChanged = true;
            } else if(this.searchedPostcode && this.searchedPostcode === postcodeLookupResult) {
                this.postcodeResearched = true;
            }
			
			// Render error message
			if (postcodeLookupResult === null || postcodeLookupResult?.length === 0) {
				this.postcodeErrorMessage = "This field is required."
				this.form.address.postcodeError = this.postcodeErrorMessage
				return
			} else if (postcodeLookupResult.length < 5 || postcodeLookupResult.length > 8) {
                this.postcodeErrorMessage = "Postcode should be between 5 and 8 characters long."
				this.form.address.postcodeError = this.postcodeErrorMessage
				return
            } else if (/[^A-Za-z0-9_.]/.test(postcodeLookupResult)) {
                this.postcodeErrorMessage = "Postcode contains invalid characters. Only letters and numbers are allowed."
				this.form.address.postcodeError = this.postcodeErrorMessage
				return
            } else if (!postcodeRegex.test(postcodeLookupResult)) {
                this.postcodeErrorMessage = "Invalid postcode format. Make sure letters and numbers are in the correct positions."
				this.form.address.postcodeError = this.postcodeErrorMessage
				return
            } else if (
				(this.postcodeChanged || this.postcodeResearched) &&
				this.$refs.postcode?.errors[0] === this.postcodeNotFoundError
			) {
				this.postcodeErrorMessage = this.postcodeNotFoundError
				this.form.address.postcodeError = this.postcodeErrorMessage
				return
			}

			if (this.postcodeErrorMessage === '') {
				this.form.address.manual = false
			}
			
            this.searchedPostcode = postcodeLookupResult;
			
            // If there's not regex errors, call lookupPostcode() - app.js
			this.lookupPostcode(this.form.address, 'postcode')
		}
	},
	computed: {
        ...mapGetters({
            people: 'people',
            customer: 'customer',
        }),
		allPhones() {
			const phones = [this.form.phone.value || ''];
			this.people.forEach(person => {
				phones.push(person.phone?.value || '');
			});
			return phones;
		},
		phoneValidationRules() {
			return {
				required: true,
				uk_number: {
					min: 10,
					max: 11
				},
				mobile_only_personal_cover: {
					coverType: this.form?.cover_type?.value
				},
				unique_phone: {
					allPhones: this.allPhones,
					currentIndex: 0,
					coverType: this.form?.cover_type?.value
				}
			};
		}
	},
	watch: {
			"form.dateOfBirth": {
				handler: function () {
                    if(!this.isBusinessFlow()){
                        const { day, month, year } = this.form.dateOfBirth;

                        if (day.value && month.value && year.value) {
                            this.dobError = false;
                            this.dobComplete = true;
                            this.allFieldsInputted(this.postcodeValid, this.phoneInputted, this.dobComplete, this.surnameInputted, this.nameInputted);
                        } else {
                            this.dobComplete = false;
                            this.allFieldsInputted(this.postcodeValid, this.phoneInputted, this.dobComplete, this.surnameInputted, this.nameInputted);
                        }
                    }
				},
				deep: true,
                immediate: true
            },
        'form.name.value': {
            handler(newVal) {
                this.nameInputted = newVal && newVal.length > 0;
                this.allFieldsInputted(this.postcodeValid, this.phoneInputted, this.dobComplete, this.surnameInputted, this.nameInputted);
            },
            deep: true,
            immediate: true
        },
        'form.surname.value': {
            handler(newVal) {
                this.surnameInputted = newVal && newVal.length > 0;
                this.allFieldsInputted(this.postcodeValid, this.phoneInputted, this.dobComplete, this.surnameInputted, this.nameInputted);
            },
            deep: true,
            immediate: true
        },
        'form.phone.value': {
            handler(newVal) {
                this.phoneInputted = newVal && newVal.length > 0;
                this.allFieldsInputted(this.postcodeValid, this.phoneInputted, this.dobComplete, this.surnameInputted, this.nameInputted);
            },
            deep: true,
            immediate: true
        },
        'form.address': {
            handler(newVal) {
				const postcodeValue = newVal.postcode.value;
                const addressSearched = newVal.results ? newVal.results.length : 0;
				const isManual = newVal.manual;
                const lineOne = newVal.line1?.value;

				// Autofill will only be detected if we have line1 and postcode values, manual and searchedPostcode is false, and results is empty.
				if (					
					this.autofillAddressSplitTest && 
					!this.searchedPostcode &&
					newVal.line1?.value && 
					newVal.postcode?.value &&
					!newVal.manual && 
					!newVal.results &&
					this.postcodeErrorMessage == ""
				) {
					this.searchedPostcode = newVal.postcode.value.replace(/\s+/g, "").toUpperCase();
					this.lineOneAutofillValue = lineOne
					this.hasAutofilled = true
					newVal.manual = true
				}
				
				if (isManual) {
					if (lineOne && lineOne.length === 0) {
						this.addressLine1Error = 'This field is required'
						newVal.lineOne = this.addressLine1Error
					} else {
						this.addressLine1Error = ''
					}

					if (postcodeValue && postcodeValue.length === 0) {
						this.postcodeErrorMessage = "This field is required."
						newVal.postcodeError = this.postcodeErrorMessage
					} else {
						this.postcodeErrorMessage = ''
					}
					
					this.postcodeValid =
                        postcodeValue &&
                        postcodeValue.length > 0 &&
                        lineOne &&
                        lineOne.length > 0
                } else {
                    if (addressSearched > 0){
                        this.postcodeValid = true;
                    }
					
					// Reset required error if postcode has value.
					if (this.postcodeErrorMessage === "This field is required." && postcodeValue && postcodeValue.length > 0) {
						this.postcodeErrorMessage = ''
					}
                }

                this.allFieldsInputted(
                    this.postcodeValid,
                    this.phoneInputted,
                    this.dobComplete,
                    this.surnameInputted,
                    this.nameInputted
                );

				if (newVal.results) {
					this.hasAddressResults = true

					// Capitalise first letter or each word for Town.
					// If you lookup, the results from the API comes as capitalised by default.
					// Covers instances of single/multi-words - Stockport, New York
					if (newVal?.town?.value) {
						this.form.address.town.value =
							newVal.town.value
							.toLowerCase()
							.split(" ")
							.map(word =>
								word.charAt(0).toUpperCase() + word.slice(1)
							)
							.join(" ")
					}
				}

				// Make sure values are present before we use replace.
				// If Postcode value changes then we'll show the lookup button again.
				if (
					this.showLookupSplitTest &&
					this.hasAutofilled &&
					this.autofillAddressSplitTest &&
					this.searchedPostcode &&
					newVal.postcode.value &&
					newVal.postcode.value.replace(/\s+/g, "").toUpperCase() !== this.searchedPostcode.replace(/\s+/g, "").toUpperCase()
				) {
					this.postcodeChanged = true
				} else if (this.autofillAddressSplitTest && this.hasAutofilled) {
					this.postcodeChanged = false
				}

				if(!this.isBusinessFlow() && this.$refs.postcode && this.$refs.postcode.errors[0] === this.postcodeNotFoundError) {
					if (this.postcodeChanged ) {
						this.postcodeErrorMessage = "This field is required."
						this.postcodeChanged = false;
						this.hideManualPostcodeError = false;
					} else if(this.postcodeResearched ) {
						this.postcodeResearched = false;
						this.hideManualPostcodeError = false;
					} else if (isManual && lineOne && lineOne.length > 0  && !this.hasAutofilled) {
						this.$refs.postcode.errors = [''];
						this.hideManualPostcodeError = true;
					} else if (isManual && !lineOne ) {
						this.hideManualPostcodeError = false;
					} else if (this.hasAutofilled && this.lineOneAutofillValue) {
						// Switch off red border input if values change after auto-filling
						if (
							this.lineOneAutofillValue !== lineOne || 
							newVal.postcode.value.replace(/\s+/g, "").toUpperCase() !== this.searchedPostcode.replace(/\s+/g, "").toUpperCase()
						) {
							this.$refs.postcode.errors = ['']
							this.hideManualPostcodeError = true
						}
					}
				}
            },
            deep: true,
            immediate: true,
        },
		'$store.state.people': {
            handler(newVal) {
                if (newVal.length === 3) {
					this.maxAdditionalMembersAdded = true
				} else {
					this.maxAdditionalMembersAdded = false
				}
            },
            deep: true,
            immediate: true
        },
    },
	mounted() {
		if(this.customer && this.customer.address_line_1 && this.customer.postcode && this.customer.city) {
			this.searchedPostcode = this.customer.postcode.replace(/\s+/g, "").toUpperCase();
		}
	},
}
</script>


<style scoped></style>
